import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Container, Row } from 'reactstrap';
import useSolutions from '@/hooks/useSolutions';
import styles from './styles.module.scss';

export const Solutions = ({
    className,
    title,
    heading,
    content,
    solutions,
    colSize = 3,
}) => {

    const items = useSolutions();
    
    const filteredItems = solutions?.length > 0 ? items.filter((solution) => solutions?.includes(solution?.id)) : items;

    if (!filteredItems || !filteredItems.length > 0) {
        return null;
    }

    return (
        <section className={`${styles.root} ${className}`}>
            <Container className="py-4 py-md-5">
                <div className="mb-5 text-center">
                    {title &&
                        <h2 className={`${heading} fw-bold`}>{title}</h2>
                    }
                    {content &&
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                    }
                </div>
                <Row className="d-flex flex-wrap justify-content-center m-0">
                    {filteredItems?.map((item, index) => (
                        <div key={index} className={`col-12 col-md-6 col-lg-${colSize} mb-4`}>
                            <a href={`/employers/${item.url_slug}`} className="card">
                                <div>
                                    <figure className="m-0">
                                        <SourceFlowImage
                                            src={item?.icon ? item.icon : "/site-assets/placeholders/img-placeholder.jpg"}
                                            size="250x"
                                            alt={item?.title}
                                            className="card-img mb-4"
                                            width="100%"
                                            height="100%"
                                        />
                                    </figure>
                                    <span>
                                        {item?.title}
                                    </span>
                                </div>
                            </a>
                        </div>
                    ))}
                </Row>
            </Container>
        </section>
    )
}

export default Solutions;
